import Channel from "./Channel";

export default {
  name: "channels",

  props: {
    channels: Array,
    userData: Object
  },

  data() {
    return {
      activeChannel: null
    };
  },

  mounted() {},

  methods: {
    showMessages(channel) {
      let refChannel = `channel_${channel.sid}`;

      this.$refs[refChannel][0].isSelectedChannel();

      this.activeChannel = channel.sid;

      this.$emit("show-message", channel);
    }
  },

  components: {
    Channel
  }
};
